export default () => {

  // if(isIE) return false
    // 交差を監視する要素①を指定する
    var observeTargets = document.querySelectorAll('[data-in-view]');

    // IntersectionObserverのオプション
    var options = {
      root: null, //交差を監視する要素②(ベース要素)nullの場合はビューポートが要素②になる 
      rootMargin: "0px 0px", //要素②に対してのマージン この場合画面50%まできたら発火
      threshold: 0 //要素①に対しての閾値。どのくらいの割合で見えたらという指定 例 1.0で100%
    };

    // IntersectionObserver起動！
    if(typeof IntersectionObserver === 'undefined'){} else{

      var observer = new IntersectionObserver(observeCallback, options);

      // 要素①の監視を開始
      observeTargets.forEach(function (observeTarget) {
        observer.observe(observeTarget);
      });
    }

    // 交差した時に発火させるコールバック①
    function observeCallback(entries) {
      entries.forEach(function (entry) {
        // var currentNum = $(entry.target).attr('data-currentItem');
        if (entry.isIntersecting && !($(entry.target).hasClass('in-view'))) {
          $(entry.target).addClass('in-view');
          // $('.l-column__localnavi-lists li a').removeClass('is-current')
          // $('.l-column__localnavi-lists li:nth-child('+currentNum+') a').addClass('is-current')
        } else {
          // $(entry.target).removeClass('in-view');
          // $('.l-column__localnavi-lists li a').removeClass('is-current')
          // $('.l-column__localnavi-lists li:nth-child('+currentNum+') a').addClass('is-current')
        }
      })
    }
};